module.exports = __webpack_public_path__ + "static/media/ht_stay_wire.6add2034.webp";